import { useRef, useEffect } from 'react';
import { Button, ScrollArea } from '@artstorefronts/ui';

interface TimeColumnProps {
  values: string[];
  selectedValue: string;
  onChange: (value: string) => void;
  isDisabled?: (value: string) => boolean;
}

export function TimeColumn({ values, selectedValue, onChange, isDisabled = () => false }: TimeColumnProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      const selectedIndex = values.indexOf(selectedValue);
      if (selectedIndex !== -1) {
        const element = scrollRef.current.querySelector(`button:nth-child(${selectedIndex + 1})`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  }, [selectedValue, values]);

  return (
    <ScrollArea className="w-auto">
      <div className="flex flex-col p-2" ref={scrollRef}>
        {values.map((value) => (
          <Button
            key={value}
            type="button"
            size="icon"
            variant={value === selectedValue ? 'default' : 'ghost'}
            className="w-full shrink-0 aspect-square"
            onClick={() => onChange(value)}
            disabled={isDisabled(value)}
          >
            {value}
          </Button>
        ))}
      </div>
    </ScrollArea>
  );
}
